import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  {
    id: 'matter-brief',
    title: 'Matter brief.',
    body: 'Status, matter type, next actions, deadlines, and the nearest one, without reopening fifteen documents.',
  },
  {
    id: 'chronology',
    title: 'Chronology.',
    body: 'Events organized in sequence from supported documents, linked to the underlying material, for your review.',
  },
  {
    id: 'gaps',
    title: 'Gaps.',
    body: 'Documents referred to but not present, unresolved dates, and inconsistencies that need a professional look.',
  },
  {
    id: 'matter-questions',
    title: 'Matter-scoped questions.',
    body: 'Ask about this file rather than starting from a blank context-free chat, with citations back to the source.',
  },
  {
    id: 'constrained-drafting',
    title: 'Constrained drafting.',
    body: 'Outlines and structured starting points built from the matter and work your practice has already approved. Not filing-ready output.',
  },
  {
    id: 'approved-work',
    title: 'Approved-work library.',
    body: 'Reviewed chronologies, checklists, and structures promoted into a controlled internal library so the next similar matter does not start from zero.',
  },
];

const LegalWorkspace = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-workspace-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content-wide">
        <h2 className="legal-h2" data-testid="legal-workspace-h2">
          What the workspace actually does
        </h2>

        <div className="legal-cards-grid mt-10">
          {cards.map((card) => (
            <div key={card.id} className="legal-card" data-testid={`legal-card-${card.id}`}>
              <p className="legal-body">
                <strong style={{ color: 'var(--text-primary)' }}>{card.title}</strong>{' '}
                {card.body}
              </p>
            </div>
          ))}
        </div>

        <p className="legal-body mt-10" data-testid="legal-workspace-footer" style={{ color: 'var(--text-secondary)' }}>
          Every one of these is a working aid. Material output requires professional review before reliance. That is a design rule, not a disclaimer.
        </p>
      </div>
    </section>
  );
};

export default LegalWorkspace;
